import { iGetActiveOptionsQueryResponse, iGetOptionOrdersQueryResponse } from "../interfaces/chrInterfaces";
import { getTokenCurrencyByAddr } from "../utils/helpers";
import { iOption } from "../interfaces/interfaces";
import { cChromiaOrder } from "./chromiaOrder";
import { cBigNumber } from "./BigNumber";
import { cStrike } from "./strike";


export class cChromiaOption implements iOption{
	optId: string;
	fTokenCurrency: string;
	fTokenAddress: string;
	uTokenCurrency: string;
	uTokenAddress: string;
	optionType: boolean; // true => call, false => put
	optionTypeText: 'Put' | 'Call';
	strike: cStrike;
	// create_time: number;
	maturityTime: number;
	period: "daily" | "weekly";
	maturityPrice: cBigNumber;
	ordersBuy: cChromiaOrder[];
	ordersSell: cChromiaOrder[];

	constructor(responseOption: iGetActiveOptionsQueryResponse, orders: iGetOptionOrdersQueryResponse[]){
		this.optId = responseOption.id.toString('hex');

		this.fTokenAddress = responseOption.ft.toString('hex');
		this.uTokenAddress = responseOption.ut.toString('hex');

		this.fTokenCurrency = getTokenCurrencyByAddr(this.fTokenAddress);
		this.uTokenCurrency = getTokenCurrencyByAddr(this.uTokenAddress);

		this.optionType = Boolean(responseOption.is_call);
		this.optionTypeText = this.optionType? 'Call' : 'Put';

		this.strike = new cStrike(responseOption.strike_price);

		// this.create_time = response_option.create_time;
		this.maturityTime = responseOption.mat_time;
		this.maturityPrice = new cBigNumber(responseOption.mat_price);

		let buyOrders: cChromiaOrder[] = [];
		let sellOrders: cChromiaOrder[] = [];

		if(orders.length > 0) {
			orders.map(order => order.type === 'sell'
				? sellOrders.push(new cChromiaOrder(order, this.uTokenCurrency))
				: buyOrders.push(new cChromiaOrder(order, this.uTokenCurrency))
			);
			// sorting (first order - best)
			// buyOrders.sort( (a, b) => +b.currentPrice - +a.currentPrice );
			// sellOrders.sort( (a, b) => +a.currentPrice - +b.currentPrice );
			buyOrders.sort( (a, b) => +b.currentPrice.sub(a.currentPrice).valueStr );
			sellOrders.sort( (a, b) => +a.currentPrice.sub(b.currentPrice).valueStr );
		}

		this.ordersBuy = buyOrders;	// add sorting?
		this.ordersSell = sellOrders;	// add sorting?

		// period
		// if (response_option.maturity_time - response_option.create_time < 60*60*48){
		// 	this.period = 'daily';
		// } else {
			// this.period = 'weekly';
			this.period = 'daily';
		// }
	}
}